<ul
  [ngClass]="['tile-view', 'flex', 'flex-wrap', singleColumn ? 'single-column' : '']"
  id="catalog_result-list_wrp_items"
  >
  @for (item of items; track item; let index = $index; ) {
    <li
      (click)="detail.emit(item)"
      [ngClass]="['border border-gray', item.header.images.length === 0 ? 'tile-bg' : '']"
      >
      <cat-result-list-tile-item
        [active]="selectIsActive(item) | async"
        [coreId]="coreId"
        [item]="item"
        [loading]="loading$ | async"
        [opened]="selectIsOpened(item) | async"
        [index]="index"
        [searchId]="searchItem.id"
      ></cat-result-list-tile-item>
    </li>
  }
</ul>
